import React from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

const CabinetPartnersStatistic = () => {
    const { t } = useTranslation();

    return (
        <div className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                РЫБА
            </div>

            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                РЫБА
            </div>
        </div>
    );
};

export default CabinetPartnersStatistic;